/**
 * UI elements
 */
class P_UI {
	constructor() {
		// this.initLoadMorePosts();
		this.initFocusInputs();
		this.showFilterMenu()
		this.initShowAnswers();
		this.initFormSurveyPopup();
    this.initClosePopups();
	}

	initLoadMorePosts() {
		if (!$('.ajax-content').length) {
			return;
		}

		var currentPage = 1;
		var maxPages = parseInt($('.ajax-content').attr('data-max-pages'), 10);

		if (maxPages <= 1) {
			$('.load-more').addClass('is-hidden');
			return
		}

		$('.pagination').addClass('is-hidden');
		$('.load-more').removeClass('is-hidden');

		$('.load-more').on('click', function (e) {
			e.preventDefault();
			var endpoint = $('.ajax-content').attr('data-ajax-url');
			var categoryId = $('.ajax-content').attr('data-category-id');
			currentPage++;

			$.ajax({
				url: endpoint + '/wp-json/plodnosc/v1/blog/',
				method: 'POST',
				beforeSend: function () {
					$('.load-more').addClass('is-loading');
				},
				data: {
					page: currentPage,
					category: categoryId
				}
			}).done(function (res) {
				console.log('RES', res);
				var newHTML = $(res.html).filter('a');
				console.log('NEW HTML', newHTML);
				var maxPages = res.pagination_max_pages;
				var contentWrapper = $('.ajax-content').find('.posts-list');

				for (var i = 0; i < newHTML.length; i++) {
					var elementToAdd = newHTML.eq(i);
					var contentPostItem = $('<li class="post"></li>');
					elementToAdd.appendTo(contentPostItem);
					contentPostItem.appendTo(contentWrapper);
					console.log('aaaaa', i);
				}

				if (maxPages > currentPage) {
					$('.load-more').removeClass('is-loading');
				} else {
					$('.load-more').addClass('is-hidden');
				}
			});
		});
	}

	initFocusInputs() {
		var inputs = document.querySelectorAll('.has-focus');
		for (var i = 0; i < inputs.length; i++) {
			var input = inputs[i];

			input.addEventListener('focus', function () {
				this.parentElement.parentElement.classList.add('is-active');
			});

			input.addEventListener('blur', function () {
				if (this.value === '') {
					this.parentElement.parentElement.classList.remove('is-active');
				}
			});
		}
	}

	showFilterMenu() {
		let filterButton = $('.show-category-menu');

		if (filterButton.length > 0) {
			for (let i = 0; i < filterButton.length; i++) {
				let filterMenu = $('.menu-category-container');
				let filterButtonClose = $('.menu-category-title');

				filterButton.eq(i).on('click', function (e) {
					e.preventDefault();
					$(document.body).addClass('no-scroll');
					filterMenu.eq(i).addClass('show');
				})

				filterButtonClose.eq(i).on('click', function (e) {
					e.preventDefault();
					$(document.body).removeClass('no-scroll');
					filterMenu.eq(i).removeClass('show');
				})
			}
		}
	}

	initShowAnswers () {
		let showAnswersButton = $('.show-answers');

		if (showAnswersButton.length > 0) {
			let showAnswersContent = $('.ss-surveyresults');

			for (let i = 0; i < showAnswersButton.length; i++) {
				showAnswersButton.eq(i).on('click', function (e) {
					e.preventDefault();
					showAnswersContent.toggleClass('opened');

					if (showAnswersContent.hasClass('opened')) {
						showAnswersButton.html('Ukryj wyniki');
					} else {
						showAnswersButton.html('Zobacz wyniki');
						$('html, body').scrollTop($('.section-poll').offset().top)
					}
				})
			}
		}
	}

	initFormSurveyPopup() {
		this.formPopup = $('.survey-popup');

    document.body.addEventListener('click', e => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#OpenSurveyPopup') {
        e.preventDefault();
        this.formPopup.removeClass('is-hidden');
        $(document.body).addClass('no-scroll');
      }
    });
	}
  
	initClosePopups() {
		let popups = $('.popup');

    if (!popups.length) {
      return
    }

    for (let i = 0; i < popups.length; i++) {
      let closeBtn = popups.eq(i).find('.popup-close');
      let closeOverlay = popups.eq(i).find('.popup-overlay');

      closeBtn.on('click', (e) => {
        e.preventDefault();
        popups.eq(i).addClass('is-hidden');
        $(document.body).removeClass('no-scroll');
      });

      closeOverlay.on('click', () => {
        popups.eq(i).addClass('is-hidden');
				$(document.body).removeClass('no-scroll');
      });
    }
	}
}
